const ROOT = '/shop/solar';

export const DIGITAL_COMMERCE_ROUTES = {
  LANDING: ROOT,
  DESIGN: `${ROOT}/design`,
};
